import React from 'react';

import type { Control } from 'react-hook-form';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography, styled } from '@mui/material';

import TagContentForm, { type TagContentFormData } from './TagContentForm';

const AccordionSummaryStyled = styled(AccordionSummary)(({ theme }) => ({
  margin: 0,
  padding: theme.spacing(1),
}));

const AccordionDetailsStyled = styled(AccordionDetails)(({ theme }) => ({
  margin: 0,
  padding: theme.spacing(1),
}));

const AccordionStyled = styled(Accordion)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  padding: theme.spacing(1),
  boxShadow: 'none',
  '&:before': {
    display: 'none',
  },
  '&:not(:last-child)': {
    marginBottom: theme.spacing(1),
  },
}));

type Props = {
  control: Control<TagContentFormData>;
  error?: string;
};

export default function TagContentCreate({ control, error }: Props) {
  return (
    <Box>
      {error && (
        <Typography variant="body2" color="error" mb={2}>
          {error}
        </Typography>
      )}
      <AccordionStyled defaultExpanded>
        <AccordionSummaryStyled expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h6">Offer Banner</Typography>
        </AccordionSummaryStyled>
        <AccordionDetailsStyled>
          <TagContentForm control={control} namePrefix="offerBanner" disableStatus />
        </AccordionDetailsStyled>
      </AccordionStyled>
      <AccordionStyled>
        <AccordionSummaryStyled expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h6">Search Banner</Typography>
        </AccordionSummaryStyled>
        <AccordionDetailsStyled>
          <TagContentForm control={control} namePrefix="searchBanner" disableStatus showLinkText />
        </AccordionDetailsStyled>
      </AccordionStyled>
      <AccordionStyled>
        <AccordionSummaryStyled expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h6">Pill (offer-pill, inflow-pill, search-pill)</Typography>
        </AccordionSummaryStyled>
        <AccordionDetailsStyled>
          <TagContentForm control={control} namePrefix="pill" disableStatus />
        </AccordionDetailsStyled>
      </AccordionStyled>
    </Box>
  );
}
